"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteActivity = exports.computePoints = exports.cappedPointDesc = exports.computePointsDescription = exports.durationFactor = exports.basePoints = exports.ActivityLogSourceTypes = exports.isCategoryActivityLog = exports.isGoalActivityLog = exports.ActivityLogKinds = void 0;
var lodash_1 = require("lodash");
exports.ActivityLogKinds = {
    GoalActivityLog: "GoalActivityLog",
    CategoryActivityLog: "CategoryActivityLog",
    PeerRecognitionLog: "PeerRecognitionLog",
};
var isGoalActivityLog = function (a) {
    return a.kind === exports.ActivityLogKinds.GoalActivityLog;
};
exports.isGoalActivityLog = isGoalActivityLog;
var isCategoryActivityLog = function (a) { return a.kind === exports.ActivityLogKinds.CategoryActivityLog; };
exports.isCategoryActivityLog = isCategoryActivityLog;
exports.ActivityLogSourceTypes = {
    AppleHealth: "AppleHealth",
    GoogleFit: "GoogleFit",
};
exports.basePoints = 0;
exports.durationFactor = 10;
var computePointsDescription = function (al) {
    switch (al.kind) {
        case exports.ActivityLogKinds.CategoryActivityLog:
            return (
            // `${basePoints} base points + (` +
            "" +
                [
                    "".concat(al.duration, " minutes"),
                    "".concat(exports.durationFactor * al.categoryBaseMultiplier, " (").concat(al.categoryName, " multiplier)"),
                    al.extraMultiplier && "".concat(al.extraMultiplier, " (challenge multiplier)"),
                ]
                    .filter(lodash_1.identity)
                    .join(" * ") +
                " = ".concat((0, exports.computePoints)(al).points, " points"));
        case exports.ActivityLogKinds.GoalActivityLog:
            return "".concat((0, exports.computePoints)(al).points, " points");
        default:
            return "";
    }
};
exports.computePointsDescription = computePointsDescription;
var cappedPointDesc = function (_a) {
    var cap = _a.cap, categoryPoints = _a.categoryPoints, goalPoints = _a.goalPoints, peerRecognitionPoints = _a.peerRecognitionPoints;
    // const dailyPoints = categoryPoints + goalPoints + peerRecognitionPoints;
    var isMaxed = categoryPoints === cap;
    var peerRecDesc = peerRecognitionPoints > 0
        ? " + ${peerRecognitionPoints} points from peer recognition"
        : "";
    var pointsDesc = isMaxed
        ? "You reached the daily points max! ".concat(categoryPoints, " points from activities + ").concat(goalPoints, " points from challenges").concat(peerRecDesc, ".")
        : "".concat(categoryPoints, " out of ").concat(cap, " points from activities + ").concat(goalPoints, " points from challenges").concat(peerRecDesc, ".");
    return pointsDesc;
};
exports.cappedPointDesc = cappedPointDesc;
var computePoints = function (al) {
    if (al.kind === exports.ActivityLogKinds.CategoryActivityLog) {
        var points = exports.basePoints +
            al.duration *
                exports.durationFactor *
                al.categoryBaseMultiplier *
                (al.extraMultiplier || 1);
        return __assign(__assign({}, al), { points: points, categoryPoints: points });
    }
    else if (al.kind === exports.ActivityLogKinds.GoalActivityLog) {
        // we had a bug in our challenges data where points were stored as strings
        // so parse them as Number just in case
        return __assign(__assign({}, al), { goalPoints: Number(al.points), points: Number(al.points) });
    }
    else if (al.kind === exports.ActivityLogKinds.PeerRecognitionLog) {
        return __assign(__assign({}, al), { peerRecognitionPoints: Number(al.recognition.pointsValue.points), points: Number(al.recognition.pointsValue.points) });
    }
    else {
        // never
        return al;
    }
};
exports.computePoints = computePoints;
// An ActivityLog has a corresponding Post on the feed of any network that the
// user belongs to, so when we delete the activity log, also delete the post.
//
// NOTE: the feed Post delete happens automatically async for GoalActivityLogs
// in a function, but for CategoryActivityLogs we need to do it synchronously so
// the user can see the result immediately. If the user is on multiple networks,
// the async function will take care of deleting those posts (it uses a
// collectionGroup query on "posts", which means it'll find all posts in all
// network, groups, and team feeds).
//
//
// updates to hide it in the UI while it async deletes?
var deleteActivity = function (al) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // TODO - delete the newsfeed post too? Or let the fn handle it?
            return [4 /*yield*/, al.ref.delete()];
            case 1:
                // TODO - delete the newsfeed post too? Or let the fn handle it?
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteActivity = deleteActivity;
//# sourceMappingURL=ActivityLog.js.map